// src/assets/constants/site.constants.js

// Este es el único valor que necesitamos aquí.
// Define cuál es el cliente que se muestra en la ruta raíz "/".
export const MAIN_TENANT_ID = "loretta3";
// export const MAIN_TENANT_ID = "congroupsas";
export const PREVIEW_LIMIT = 100;
